export default __webpack_public_path__ + "static/metal-working-collage-4b5d5bbc834afb37505553c178e2afc8.jpg";